module.exports = __webpack_public_path__ + "img/schema.097f1daf.png";